// Designation detail page (CHG-1251 / ITER-3374).
//
// Thin per the v11 brief: ≤30 LOC. All configuration in @generated/screens.
// Future generator regenerates designationDetailConfig from
// designation.entity-hint.yaml (CHG-1237) without touching this file.
//
// Spec: specs/tier-05-experience/designation-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { designationDetailConfig } from "../generated/screens/designation-detail";

export function DesignationDetail() {
  return <DetailPage config={designationDetailConfig} />;
}
